import { SubscriptionService } from '@/lib/Subscription';
import { useQuery } from '@tanstack/react-query';

/**
 * Returns whether the current user has an active subscription.
 * Use for feature gating (e.g. Learn menu) independent of trading permissions.
 *
 * @param isChild - When true, checks subscription in child (teen) context
 * @param enabled - Whether the query should run (e.g. false when not authenticated)
 */
export default function useHasActiveSubscription(isChild = false, enabled = true) {
  const query = useQuery({
    queryKey: ['subscription', 'has-active', isChild],
    queryFn: () => SubscriptionService.hasActiveSubscription(isChild),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  });

  return {
    ...query,
    hasActiveSubscription: query.data?.hasActive ?? false,
  };
}
